
const TimeCounter = ({startTime, tzOffset}) => {
  const stime = startTime.toISOString().replace(/T/,' ').replace(/\.\d\d\dZ$/,'');
  return <div className="duration"><iframe title="clock" className="begin-process" src={"/clock.html?start_time="+stime+"&tz_offset="+tzOffset}></iframe></div>
};

export default TimeCounter;
